import React from 'react';
import { Typography } from '@material-ui/core';
import { useFormState } from 'react-final-form';

const defaultGetType = (values = {}) => values.type;

/**
 * Generic documentation box for react-admin forms.
 * Shows the documentation of the selected type, if one exists.
 *
 * Props:
 * - docs: map type -> { title, items }, where items is a list of strings or nodes
 * - getType: (formValues) => type key, defaults to values.type
 */
const TypeDocs = ({ docs = {}, getType = defaultGetType }) => {
    const { values } = useFormState();
    const doc = docs[getType(values)];
    if (!doc || !doc.items || doc.items.length === 0) return null;
    return (
        <div style={{ maxWidth: 640, marginBottom: 16 }}>
            {doc.title && (
                <Typography variant="subtitle2" component="p">
                    {doc.title}
                </Typography>
            )}
            <Typography variant="body2" color="textSecondary" component="div">
                <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                    {doc.items.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </Typography>
        </div>
    );
};

export default TypeDocs;
